export const countries = [
    {
       'id': 1,
       'cod': 'es',
       'country': 'Spain'
    },
    {
        'id': 2,
        'cod': 'pt',
        'country': 'Portugal'
     },
];
